export default __webpack_public_path__ + "static/media/2.e3187a89.jpg";